<template>
  <LinkButton
    tag="nuxt-link"
    to="/merkliste"
    data-tealium-rel="header.button.merkliste"
    variant="transparent"
    class="bookmark-indicator"
    active-class="navigation-controls__link--active"
    :aria-label="`Merkliste, ${
      productBookmarks?.length === 1 ? '1 Produkt' : `${productBookmarks?.length || 0} Produkte`
    }`"
  >
    <SvgIcon
      no-icon-class
      class="btn__icon bookmark-indicator__icon"
      :image="bookmarkIcon"
    />

    <client-only>
      <CountBadge
        v-if="isBookmarkingAvailable"
        :value="productBookmarks.length"
        class="bookmark-indicator__count"
        aria-hidden="true"
      />
    </client-only>
  </LinkButton>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';
import bookmarkIcon from '~/assets/images/icon-bookmark.svg';
import CountBadge from '~/components/count-badge.vue';
import useProductBookmarks from '~/composables/product-bookmarks';

const { isBookmarkingAvailable, productBookmarks } = useProductBookmarks();
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.bookmark-indicator {
  --badge-color: var(--color-primary);

  > span:not(.count-badge) {
    // This is a placeholder for the client-only and will create a layout shift.
    display: none;
  }

  &__count {
    position: absolute;
    right: -4px;
    top: 15px;
  }

  &__icon {
    fill: none;
    stroke: currentColor;
  }
}
</style>
